import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceService } from './resource';
import { CacheService } from '../cache';
import { Resource } from '../../models/resource';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService extends ResourceService<Resource> {
  constructor(protected http: HttpClient, protected cache: CacheService) {
    super(http, cache, 'invoices');
  }

  /**
   * Get Invoices
   * GET /invoices
   */
  getInvoices(params?: any): Observable<any> {
    return this.http.get<any>(`${this.endpoint}`, { params });
  }

  /**
   * Mark Invoice as Paid (admin only)
   * PUT /invoices/:id/mark-paid
   * Header: X-Requested-With: admin
   */
  markInvoicePaid(id: string): Observable<any> {
    const headers = new HttpHeaders({ 'X-Requested-With': 'admin' });
    return this.http.put<any>(`${this.endpoint}/${id}/mark-paid`, {}, { headers });
  }
}
